import { render, staticRenderFns } from "./AnimateOnVisible.vue?vue&type=template&id=63ede055&"
import script from "./AnimateOnVisible.vue?vue&type=script&lang=js&"
export * from "./AnimateOnVisible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports